// export const surveySteps = [
//     {
//       id: 0,
//       nextStep: 1,
//       area: 'Masterclass',
//       masterclass: true,
//       stepTitle: 'Online Resource Center Masterclass',
//       stepDescription: ` 
//       <p>In the journey towards economic empowerment, Black future wealth builders face a unique set of challenges. Systemic barriers, wealth gaps, and even unconscious biases can create roadblocks on the path to financial success. But fear not, this isn\'t a dead end. This is an opportunity to explore the economic realities Black entrepreneurs and investors like yourselves will encounter so you are equipped  and equip themselves with the knowledge and strategies to break through those barriers and build generational wealth. Let\'s dive in! Do you dream of leading with innovation, building a thriving business, and making a positive impact on the world? If so, this exclusive Masterclass video series is your roadmap to success.</p><br /> <strong>In this comprehensive program, you\'ll gain insights from inspirational leaders on:</strong>
//       <ul class="disc">
//       <li>Visionary Leadership: Discover the secrets to inspiring and motivating others while crafting a clear vision for the future.</li>
//       <li>Entrepreneurship Essentials: Learn the fundamental principles of building a successful business, from concept to execution.</li>
//       <li>Building Wealth: Explore powerful strategies for achieving financial security and realizing your entrepreneurial goals.</li>
//       <li>The Power of Philanthropy: Uncover the art of giving back and discover how to leverage your resources to make a lasting difference.</li>
//     </ul>`,
//       videoUrl: 'https://example.com/video1.mp4',
//       questions: [
//         { id: 1, title: "What is net worth?", options: ['What you are worth socially once you combine your social media followers and personal contacts.', 'What you are worth financially once you combine what you own (your assets) and what you owe (your liabilities).', 'What you are worth intellectually once you combine your degrees and work experience.'], correctAnswer: 'What you are worth intellectually once you combine your degrees and work experience.' },
//         { id: 2, title: "Test Quest2", options: ['A', 'B', 'C', 'D'], correctAnswer: 'B' },
//         { id: 3, title: "Question 2", options: ['A', 'B', 'C', 'D'], correctAnswer: 'A' },
//         { id: 4, title: "Question 3", options: ['A', 'B', 'C', 'D'], correctAnswer: 'D' },
//         { id: 5, title: "Question 4", options: ['A', 'B', 'C', 'D'], correctAnswer: 'D' },
  
//       ]
//     },
//     {
//       id: 1,
//       decision: true,
//       options: [
//         { text: 'Finances & Philanthropy', nextStep: 2 },
//         { text: 'Entrepreneurship & Philanthropy', nextStep: 8 }
//       ]
//     },
//     // Paths A and B with additional quizzes or content
//     {
//       id: 2,
//       area: 'Finances & Philanthropy',
//       stepTitle: 'Finances & Philanthropy Pre-Workshop Assessment',
//       stepDescription: ``,
//       preWorkshop: true, // Adding the preWorkshop property
//       questions: [
//         { id: 1, title: "What is net worth?", options: [
//           'What you are worth socially once you combine your social media followers and personal contacts.', 
//           'What you are worth financially once you combine what you own (your assets) and what you owe (your liabilities).', 
//           'What you are worth intellectually once you combine your degrees and work experience.', 
//         ],
//         correctAnswer: 'What you are worth socially once you combine your social media followers and personal contacts.' 
//       },
//       { id: 2, title: "Why is it important to at least pay the minimums of credit cards?", options: [
//         'So that I can increase my savings.', 
//         'So that I can spend more money.', 
//         'So that I can maintain a good credit score.', 
//       ],
//       correctAnswer: 'So that I can maintain a good credit score.'
//       },
//       { id: 3, title: "What is a credit score?", options: [
//         'The number—based on your credit history, ranging from 300 (low) - 850 (high)—lenders use to determine the likelihood of being repaid on time if they give you a loan or a credit card.', 
//         'The number—based on your saving history, ranging from 300 (low) - 850 (high)—lenders use to determine the likelihood of being repaid on time if they give you a loan or a credit card.', 
//         'The number—based on your investment history, ranging from 300 (low) - 850 (high)—lenders use to determine the likelihood of being repaid on time if they give you a loan or a credit card.', 
//       ],
//       correctAnswer: 'The number—based on your saving history, ranging from 300 (low) - 850 (high)—lenders use to determine the likelihood of being repaid on time if they give you a loan or a credit card.', 
  
//       },
//       { id: 4, title: "Why is it important to at least pay the minimums of credit cards?", options: [
//         'So that I can increase my savings.', 
//         'So that I can spend more money.', 
//         'So that I can maintain a good credit score.', 
//       ],
//       correctAnswer: 'So that I can increase my savings.', 
//       },
//       { id: 5, title: "2Why is it important to at least pay the minimums of credit cards?", options: [
//         'So that I can increase my savings.', 
//         'So that I can spend more money.', 
//         'So that I can maintain a good credit score.', 
//       ],
//       correctAnswer: 'So that I can maintain a good credit score.',
//       },
//       { id: 6, title: "3Why is it important to at least pay the minimums of credit cards?", options: [
//         'So that I can increase my savings.', 
//         'So that I can spend more money.', 
//         'So that I can maintain a good credit score.', 
//       ],
//       correctAnswer: 'So that I can spend more money.',  
//       },
//       { id: 7, title: "4Why is it important to at least pay the minimums of credit cards?", options: [
//         'So that I can increase my savings.', 
//         'So that I can spend more money.', 
//         'So that I can maintain a good credit score.', 
//       ],
//       correctAnswer: 'So that I can spend more money.', 
//       },
//       { id: 8, title: "5Why is it important to at least pay the minimums of credit cards?", options: [
//         'So that I can increase my savings.', 
//         'So that I can spend more money.', 
//         'So that I can maintain a good credit score.', 
//       ],
//       correctAnswer:   'So that I can maintain a good credit score.', 
//       },
//       ],
//       nextStep: 3
//     },
  
//     {
//       id: 3,
//       area: 'Finances & Philanthropy',
//       videoUrl: 'https://example.com/video1.mp4',
//       stepTitle: 'The Economic Realities Future Black Wealth Builders Face ',
//       stepDescription: `In the journey towards economic empowerment, Black future wealth builders face a unique set of challenges. Systemic barriers, wealth gaps, and even unconscious biases can create roadblocks on the path to financial success. But fear not, this isn't a dead end. This is an opportunity to explore the economic realities Black entrepreneurs and investors like yourselves will encounter, so you are equipped and equip ourselves with the knowledge and strategies to break through those barriers and build generational wealth. Let's dive in! Pass and unlock Where You Stand and Your Role as a Black Wealth Builder.`,
//       preWorkshop: false, // Adding the preWorkshop property
//       questions: [
//         { id: 1, title: "What is net worth?", options: ['A', 'B', 'C', 'D'], correctAnswer: 'D' },
//         { id: 2, title: "Test Quest2", options: ['A', 'B', 'C', 'D'], correctAnswer: 'B' },
//         { id: 3, title: "Question 2", options: ['A', 'B', 'C', 'D'], correctAnswer: 'A' },
//         { id: 4, title: "Question 3", options: ['A', 'B', 'C', 'D'], correctAnswer: 'D' },
//         { id: 5, title: "Question 4", options: ['A', 'B', 'C', 'D'], correctAnswer: 'D' },
  
//       ],
//       nextStep: 4
//     },
//     {
//       id: 4,
//       area: 'Finances & Philanthropy',
//       videoUrl: 'https://example.com/video1.mp4',
//       stepTitle: 'Where You Stand and Your Role as a Black Wealth Builder ',
//       stepDescription: `Financial freedom shouldn't just be a dream; it’s a necessity! The dream of financial freedom isn't just a dream; it's a necessity. In this video, we'll dive deep into the current state of Black wealth globally, and in America. We'll explore the challenges faced by the Black community–all while empowering ,but more importantly, we'll empower YOU to take action.
//         <br /><br />Whether you're just starting your financial journey or looking to level up, this video is your roadmap to building generational wealth. Let's break down the barriers, unpack the strategies, and claim your rightful place as a Black wealth builder. Pass and unlock the Discussion Regarding Generational Wealth.`,
//       preWorkshop: false, // Adding the preWorkshop property
//       questions: [
//         { id: 1, title: "What is net worth?", options: ['What you are worth socially once you combine your social media followers and personal contacts.', 'What you are worth financially once you combine what you own (your assets) and what you owe (your liabilities).', 'What you are worth intellectually once you combine your degrees and work experience.'], correctAnswer: 'What you are worth intellectually once you combine your degrees and work experience.' },
//         { id: 2, title: "Test Quest2", options: ['A', 'B', 'C', 'D'], correctAnswer: 'B' },
//         { id: 3, title: "Question 2", options: ['A', 'B', 'C', 'D'], correctAnswer: 'A' },
//         { id: 4, title: "Question 3", options: ['A', 'B', 'C', 'D'], correctAnswer: 'D' },
//         { id: 5, title: "Question 4", options: ['A', 'B', 'C', 'D'], correctAnswer: 'D' },
  
//       ],
//       nextStep: 5
//     },
//     {
//       id: 5,
//       area: 'Finances & Philanthropy',
//       videoUrl: 'https://example.com/video1.mp4',
//       stepTitle: 'Where You Stand and Your Role as a Black Wealth Builder ',
//       stepDescription: `Ever wondered why some families seem to have a financial head start? In this discussion, we delve into the concept of generational wealth, exploring its impact and strategies for building it. Pass and unlock the Overview of How to Build Generational Wealth.`,
//       preWorkshop: false, // Adding the preWorkshop property
//       questions: [
//         { id: 1, title: "What is net worth?", options: ['What you are worth socially once you combine your social media followers and personal contacts.', 'What you are worth financially once you combine what you own (your assets) and what you owe (your liabilities).', 'What you are worth intellectually once you combine your degrees and work experience.'], correctAnswer: 'What you are worth intellectually once you combine your degrees and work experience.' },
//         { id: 2, title: "Test Quest2", options: ['A', 'B', 'C', 'D'], correctAnswer: 'B' },
//         { id: 3, title: "Question 2", options: ['A', 'B', 'C', 'D'], correctAnswer: 'A' },
//         { id: 4, title: "Question 3", options: ['A', 'B', 'C', 'D'], correctAnswer: 'D' },
//         { id: 5, title: "Question 4", options: ['A', 'B', 'C', 'D'], correctAnswer: 'D' },
  
//       ],
//       nextStep: 6
//     },
//     {
//       id: 6,
//       area: 'Finances & Philanthropy',
//       videoUrl: 'https://example.com/video1.mp4',
//       stepTitle: 'An Overview of How to Build Generational Wealth',
//       stepDescription: `In this video, we'll crack the code on building generational wealth. We'll break down the clear steps you can take to secure your financial future and set your loved ones up for success. From budgeting basics to investment strategies, this video will equip you with the knowledge and tools to build a lasting financial foundation for generations to come. Let's dive in!  Pass and unlock the 3-Year Financial Plan for Generational Wealth & Philanthropy.`,
//       preWorkshop: false, // Adding the preWorkshop property
//       questions: [
//         { id: 1, title: "What is net worth?", options: ['What you are worth socially once you combine your social media followers and personal contacts.', 'What you are worth financially once you combine what you own (your assets) and what you owe (your liabilities).', 'What you are worth intellectually once you combine your degrees and work experience.'], correctAnswer: 'What you are worth intellectually once you combine your degrees and work experience.' },
//         { id: 2, title: "Test Quest2", options: ['A', 'B', 'C', 'D'], correctAnswer: 'B' },
//         { id: 3, title: "Question 2", options: ['A', 'B', 'C', 'D'], correctAnswer: 'A' },
//         { id: 4, title: "Question 3", options: ['A', 'B', 'C', 'D'], correctAnswer: 'D' },
//         { id: 5, title: "Question 4", options: ['A', 'B', 'C', 'D'], correctAnswer: 'D' },
  
//       ],
//       nextStep: 7
//     },
//     {
//       id: 7,
//       area: 'Finances & Philanthropy',
//       videoUrl: '',
//       stepTitle: '3-Year Financial Plan for Generational Wealth & Philanthropy',
//       stepDescription: ``,
//       preWorkshop: false, // Adding the preWorkshop property
//       questions: [
//         { id: 1, title: "Question 4", options: ['A', 'B', 'C', 'D'], correctAnswer: 'D' },
  
//       ],
//       nextStep: 21
//     },



//     // Starting Entrepreneurship & Philanthropy Questions
  
//     {
//       id: 8,
//       area: 'Entrepreneurship & Philanthropy',
//       stepTitle: 'Entrepreneurship & Philanthropy Pre-Workshop Assessment',
//       stepDescription: ``,
//       preWorkshop: true, // Adding the preWorkshop property
//       questions: [
//         { id: 1, title: "What is net worth?", options: [
//           'What you are worth socially once you combine your social media followers and personal contacts.', 
//           'What you are worth financially once you combine what you own (your assets) and what you owe (your liabilities).', 
//           'What you are worth intellectually once you combine your degrees and work experience.', 
//         ],
//         correctAnswer: 'What you are worth socially once you combine your social media followers and personal contacts.' 
//       },
//       { id: 2, title: "Why is it important to at least pay the minimums of credit cards?", options: [
//         'So that I can increase my savings.', 
//         'So that I can spend more money.', 
//         'So that I can maintain a good credit score.', 
//       ],
//       correctAnswer: 'So that I can maintain a good credit score.'
//       },
//       { id: 3, title: "What is a credit score?", options: [
//         'The number—based on your credit history, ranging from 300 (low) - 850 (high)—lenders use to determine the likelihood of being repaid on time if they give you a loan or a credit card.', 
//         'The number—based on your saving history, ranging from 300 (low) - 850 (high)—lenders use to determine the likelihood of being repaid on time if they give you a loan or a credit card.', 
//         'The number—based on your investment history, ranging from 300 (low) - 850 (high)—lenders use to determine the likelihood of being repaid on time if they give you a loan or a credit card.', 
//       ],
//       correctAnswer: 'The number—based on your saving history, ranging from 300 (low) - 850 (high)—lenders use to determine the likelihood of being repaid on time if they give you a loan or a credit card.', 
  
//       },
//       { id: 4, title: "Why is it important to at least pay the minimums of credit cards?", options: [
//         'So that I can increase my savings.', 
//         'So that I can spend more money.', 
//         'So that I can maintain a good credit score.', 
//       ],
//       correctAnswer: 'So that I can increase my savings.', 
//       },
//       { id: 5, title: "2Why is it important to at least pay the minimums of credit cards?", options: [
//         'So that I can increase my savings.', 
//         'So that I can spend more money.', 
//         'So that I can maintain a good credit score.', 
//       ],
//       correctAnswer: 'So that I can maintain a good credit score.',
//       },
//       { id: 6, title: "3Why is it important to at least pay the minimums of credit cards?", options: [
//         'So that I can increase my savings.', 
//         'So that I can spend more money.', 
//         'So that I can maintain a good credit score.', 
//       ],
//       correctAnswer: 'So that I can spend more money.',  
//       },
//       { id: 7, title: "4Why is it important to at least pay the minimums of credit cards?", options: [
//         'So that I can increase my savings.', 
//         'So that I can spend more money.', 
//         'So that I can maintain a good credit score.', 
//       ],
//       correctAnswer: 'So that I can spend more money.', 
//       },
//       { id: 8, title: "5Why is it important to at least pay the minimums of credit cards?", options: [
//         'So that I can increase my savings.', 
//         'So that I can spend more money.', 
//         'So that I can maintain a good credit score.', 
//       ],
//       correctAnswer:   'So that I can maintain a good credit score.', 
//       },
//       ],
//       nextStep: 9
//     },
//     {
//       id: 9,
//       area: 'Entrepreneurship & Philanthropy',
//       videoUrl: 'https://example.com/video1.mp4',
//       stepTitle: 'Developing Your Community-Minded Business Concept',
//       stepDescription: `Want to turn your passion for making a difference into a thriving business? In this video, we'll guide you through the process of developing a community-minded business concept. Learn how to identify local needs, create a business model with social impact, and build a successful venture that strengthens your community. Pass and unlock Legalizing Your Business Video.`,
//       preWorkshop: false, // Adding the preWorkshop property
//       questions: [
//         { id: 1, title: "What is net worth?", options: ['What you are worth socially once you combine your social media followers and personal contacts.', 'What you are worth financially once you combine what you own (your assets) and what you owe (your liabilities).', 'What you are worth intellectually once you combine your degrees and work experience.'], correctAnswer: 'What you are worth intellectually once you combine your degrees and work experience.' },
//         { id: 2, title: "Test Quest2", options: ['A', 'B', 'C', 'D'], correctAnswer: 'B' },
//         { id: 3, title: "Question 2", options: ['A', 'B', 'C', 'D'], correctAnswer: 'A' },
//         { id: 4, title: "Question 3", options: ['A', 'B', 'C', 'D'], correctAnswer: 'D' },
//         { id: 5, title: "Question 4", options: ['A', 'B', 'C', 'D'], correctAnswer: 'D' },
  
//       ],
//       nextStep: 10
//     },
//     {
//       id: 10,
//       area: 'Entrepreneurship & Philanthropy',
//       videoUrl: 'https://example.com/video1.mp4',
//       stepTitle: 'Legalizing Your Business',
//       stepDescription: `Learn the ins and outs of legalizing your business. This video will guide you through the process step by step. Pass and unlock Opening Your Business Bank Account Video.`,
//       preWorkshop: false, // Adding the preWorkshop property
//       questions: [
//         { id: 1, title: "What is net worth?", options: ['What you are worth socially once you combine your social media followers and personal contacts.', 'What you are worth financially once you combine what you own (your assets) and what you owe (your liabilities).', 'What you are worth intellectually once you combine your degrees and work experience.'], correctAnswer: 'What you are worth intellectually once you combine your degrees and work experience.' },
//         { id: 2, title: "Test Quest2", options: ['A', 'B', 'C', 'D'], correctAnswer: 'B' },
//         { id: 3, title: "Question 2", options: ['A', 'B', 'C', 'D'], correctAnswer: 'A' },
//         { id: 4, title: "Question 3", options: ['A', 'B', 'C', 'D'], correctAnswer: 'D' },
//         { id: 5, title: "Question 4", options: ['A', 'B', 'C', 'D'], correctAnswer: 'D' },
  
//       ],
//       nextStep: 11
//     },
//     {
//       id: 11,
//       area: 'Entrepreneurship & Philanthropy',
//       videoUrl: 'https://example.com/video1.mp4',
//       stepTitle: 'Opening Your Business Bank Account',
//       stepDescription: `Lorem Ipsum Dolor`,
//       preWorkshop: false, // Adding the preWorkshop property
//       questions: [
//         { id: 1, title: "What is net worth?", options: ['What you are worth socially once you combine your social media followers and personal contacts.', 'What you are worth financially once you combine what you own (your assets) and what you owe (your liabilities).', 'What you are worth intellectually once you combine your degrees and work experience.'], correctAnswer: 'What you are worth intellectually once you combine your degrees and work experience.' },
//         { id: 2, title: "Test Quest2", options: ['A', 'B', 'C', 'D'], correctAnswer: 'B' },
//         { id: 3, title: "Question 2", options: ['A', 'B', 'C', 'D'], correctAnswer: 'A' },
//         { id: 4, title: "Question 3", options: ['A', 'B', 'C', 'D'], correctAnswer: 'D' },
//         { id: 5, title: "Question 4", options: ['A', 'B', 'C', 'D'], correctAnswer: 'D' },
  
//       ],
//       nextStep: 12
//     },
//     {
//       id: 12,
//       area: 'Community-Minded Business Concept Form',
//       stepTitle: 'PRODUCTS, SERVICES & GIVING BACK - Step 1',
//       stepDescription: `What products and/or services does your business offer?`,
//       preWorkshop: false,
//       questions: [],
//       formFields: [
//         { id: 1, title: "What problems/issues do your products and/or services solve/address and how do they do so? (1,200 characters max (Guidance: Your products and/or services should fill unmet needs. Unmet needs refer to problems/issues that are truly painful, inconvenient, irritating, etc. When it comes to such problems/issues, people will go out of their way to access products and/or services that appear to be potential remedies.)", type: "textarea", maxChars: 1200 },
//         { id: 2, title: "What makes your products and/or services unique? (Guidance: What sets your business apart from other businesses?) (500 characters max)", type: "textarea", maxChars: 500 },
//         { id: 3, title: "How do you measure the effectiveness of your products and/or services and what results/impact do you need to see in order for you to know that your business is successful? (1,200 characters max)", type: "textarea", maxChars: 1200 },
//         { id: 4, title: "If your business is not a nonprofit that puts all of its revenue towards addressing a particular social problem negatively impacting a significant portion of the global Black community or a social enterprise that uses its revenue from selling a good or service towards furthering a cause benefiting Black people, what private philanthropic initiatives can your business lead that aim to address the root causes of a major problem plaguing the Black race? (2,000 characters max)", type: "textarea", maxChars: 2000 }
//       ],
//       nextStep: 13
//     },
//     {
//       id: 13,
//       area: 'Community-Minded Business Concept Form',
//       stepTitle: 'CORE PRINCIPLES & OBJECTIVES - Step 2',
//       stepDescription: `Please provide detailed information about your market strategy.`,
//       preWorkshop: false,
//       questions: [],
//       formFields: [
//         { id: 1, title: "What is your business' mission statement? (Guidance: An organization's role in working toward its vision. A great mission clearly identifies and communicates the target audience, the goal for serving your beneficiaries/customers and what sets your business apart.) (150 characters max)", type: "textarea", maxChars: 150 },
//         { id: 2, title: "What is your business' vision statement? (Guidance: A vision is the desired future state. This should be a big picture aspirational description of what you would like your business to accomplish in the future.) (300 characters max)", type: "textarea", maxChars: 300 }
//       ],
//       nextStep: 14
//     },
//     {
//       id: 14,
//       area: 'Community-Minded Business Concept Form',
//       stepTitle: 'YOUR MOTIVATION - Step 3',
//       stepDescription: ``,
//       preWorkshop: false,
//       questions: [],
//       formFields: [
//         { id: 1, title: "What life experiences have inspired you to create this business? (1,000 characters max)", type: "textarea", maxChars: 1000 },
//         { id: 2, title: "What are your more personal dreams and ambitions for your business? (Guidance: Will your business revolutionize the way a certain sector works or the way that people do a certain thing or set of things? Will your business dominate a certain sector? Will your business break international barriers and exist all around the world?) (1,000 characters max)", type: "textarea", maxChars: 1000 },
//         { id: 3, title: "Why do you feel the world needs your business? (1,000 characters max)", type: "textarea", maxChars: 1000 }

//       ],
//       nextStep: 15
//     },
//     {
//       id: 15,
//       area: 'Community-Minded Business Concept Form',
//       stepTitle: 'ORGANIZATIONAL DETAILS - Step 4',
//       stepDescription: ``,
//       preWorkshop: false,
//       questions: [],
//       formFields: [
//         { id: 1, title: "What is the name of your business? (Directions: The name of your business may change many times before you register it formally. Provide us with the business name you currently like the most.)", type: "textarea", maxChars: 500 },
//         { id: 2, title: "What country or countries does your business operate within?", type: "textarea", maxChars: 500 },
//         { id: 3, title: "What is your domain name (i.e., web address)? (Directions: Check GoDaddy or other relevant and reputable domain registrar companies to see if your preferred domain name is available in the country where your business will be based.)", type: "textarea", maxChars: 500 },
//         { id: 4, title: "What legal business organizational structure is your business? (Guidance: Is your business a sole proprietorship, a limited liability company, a partnership, etc.?)", type: "textarea", maxChars: 500 },
//         { id: 5, title: "Why did you choose this business structure over other legal structures? (300 characters max)", type: "textarea", maxChars: 300 },
//         { id: 6, title: "What industry sector(s) does your business operate within? (Examples: Media, advertising, games, performing arts, architecture, fashion, technology, charity, etc.)", type: "textarea", maxChars: 500 },
//         { id: 7, title: "Who are the founding business owners and leaders, what are their titles, what aspects of their backgrounds are relevant to the positions they hold, and what is your relationship with them? (Directions: Include details about yourself and the other founding owners and main leaders.)", type: "textarea", maxChars: 500 },
//         { id: 8, title: "What are the roles of the owners/leaders? (Directions: Though you may have co-owners/co-leaders, you will not all be dedicated to the same work. Describe the role each owner/leader will play within the business.)", type: "textarea", maxChars: 500 },
//         { id: 9, title: "Copy and paste your draft logo or official logo.", type: "file" },
//         { id: 10, title: "Copy and paste an image that captures the true essence of your products and/or services. (Guidance: Think of an image you would be proud to see on your website. For example, if your business empowers young Black men to purchase real estate, you may upload an image of a young Black man smiling and putting a “sold” sign in a plot of land.)", type: "textarea", maxChars: 500 },

//       ],
//       nextStep: 16
//     },
//     {
//       id: 16,
//       area: 'Community-Minded Business Concept Form',
//       stepTitle: 'THE MARKET - Step 5',
//       stepDescription: ``,
//       preWorkshop: false,
//       questions: [],
//       formFields: [
//         { id: 1, title: "What is your business’ target market and why? (Guidance: Who will be the main beneficiaries of your products and/or services? Your target market may be one group of people or a set of different groups of people.) (500 characters max)", type: "textarea", maxChars: 500 },
//         { id: 2, title: "How would you like your target market to view your brand? (500 characters max)", type: "textarea", maxChars: 500 },
//         { id: 3, title: "Why do you feel the world needs your business? (1,000 characters max)", type: "textarea", maxChars: 1000 }

//       ],
//       nextStep: 17
//     },
//     {
//       id: 17,
//       area: 'Community-Minded Business Concept Form',
//       stepTitle: 'COMPETITIVE STATUS - Step 6',
//       stepDescription: ``,
//       preWorkshop: false,
//       questions: [],
//       formFields: [
//         { id: 1, title: "Who are your competitors and what sets you apart from them? (Directions: Detail a minimum of three competitors including their URLs and clear explanations regarding what sets you apart from them.)", type: "textarea", maxChars: 500 },
//         { id: 2, title: "What are the most common challenges businesses within your industry face? (1,000 characters max)", type: "textarea", maxChars: 1000 },
//         { id: 3, title: "What competitive advantages do you believe your business has that would help it to overcome those challenges? (Guidance: Do you have unique distribution channels, provide low costs for typically expensive products, offer high quality services for less, effect change through an underserved group using new technology, etc.?) (1,000 characters max)", type: "textarea", maxChars: 1000 },
//         { id: 4, title: "Based on relevant research, how do you see the market your business falls within changing in the near future and how do you think such changes will impact your presumed competitive advantage? (1,000 characters max)", type: "textarea", maxChars: 1000 },


//       ],
//       nextStep: 18
//     },
//     {
//       id: 18,
//       area: 'Community-Minded Business Concept Form',
//       stepTitle: 'REVENUE - Step 7',
//       stepDescription: ``,
//       preWorkshop: false,
//       questions: [],
//       formFields: [
//         { id: 1, title: "What are the key activities generating revenue for your business? (Examples: The selling of products, the provision of services in exchange for a fee, or fundraising through grant writing, events, board contributions, email campaigns, crowdfunding, etc.)", type: "textarea", maxChars: 1000 },
//         { id: 2, title: "What is your first year’s operating budget? (Directions: Submit a budget including all anticipated sources of capital and expenses. The below sample budget includes fundamental expenses to consider.)", type: "textarea", maxChars: 1000 },
//         { id: 3, title: "Sample Budget", type: "number", maxChars: 12 },
//         { id: 4, title: "Sources of Capital", type: "number", maxChars: 50 },
//         { id: 5, title: "Personal Savings", type: "number", maxChars: 12 },
//         { id: 6, title: "Other Source of Funding", type: "number", maxChars: 50 },
//         { id: 7, title: "Total Budget Amount", type: "number", maxChars: 12 },
//         { id: 8, title: "Expenses", type: "number", maxChars: 200 },
//         { id: 9, title: "Incorporation Fees", type: "number", maxChars: 12 },
//         { id: 10, title: "Local Business Registration Fees", type: "number", maxChars: 12 },
//         { id: 11, title: "Intellectual Property Filing Fees", type: "number", maxChars: 12 },
//         { id: 12, title: "Legal Fees", type: "number", maxChars: 12 },
//         { id: 13, title: "Marketing", type: "number", maxChars: 12 },
//         { id: 14, title: "Accounting", type: "number", maxChars: 12 },
//         { id: 15, title: "Website", type: "number", maxChars: 100 },
//         { id: 16, title: "Internet", type: "number", maxChars: 12 },
//         { id: 17, title: "Phone", type: "number", maxChars: 15 },
//         { id: 18, title: "Professional Consultants", type: "number", maxChars: 12 },
//         { id: 19, title: "Insurance", type: "number", maxChars: 12 },
//         { id: 20, title: "Travel", type: "number", maxChars: 12 },
//         { id: 21, title: "Mail/Shipping", type: "number", maxChars: 12 },
//         { id: 22, title: "Inventory", type: "number", maxChars: 12 },
//         { id: 23, title: "Equipment", type: "number", maxChars: 12 },
//         { id: 24, title: "Taxes", type: "number", maxChars: 12 },
//         { id: 25, title: "Other", type: "text", maxChars: 50 },
//         { id: 26, title: "Total Expenses", type: "number", maxChars: 12 },
//         { id: 27, title: "Budget Surplus/Deficit", type: "number", maxChars: 12 }
//       ],
//       nextStep: 19
//     },
//     {
//       id: 19,
//       decision: true,
//       options: [
//         { text: 'Finance & Philanthropy Resources', nextStep: 20 },
//         { text: 'Wealth Building Stage', nextStep: 21 }
//       ]
//     },
//         // Starting Wealth Building Stage
//     {
//       id: 21,
//       decision: true,
//       options: [
//         { text: 'Undebting (81-100%) Net Worth = Very Negative Pay off debt.', nextStep: 1 },
//         { text: 'Saving (61-80%) Net Worth = Negative Pay off debt and save.', nextStep: 2 },
//         { text: 'Securing (21-40%) Net Worth = Positive Pay off debt, save, invest and document legacy.', nextStep: 3 },
//         { text: 'Saving (61-80%) Net Worth = Negative Pay off debt and save.', nextStep: 3 },
//       ]
//     },
//   ];
  
import masterclassSteps from './Masterclass';
import financesPhilanthropySteps from './FinancesPhilanthropy';
import entrepreneurshipPhilanthropySteps from './EntrepreneurshipPhilanthropy';
import communityMindedBusinessConceptFormSteps from './CommunityMindedBusinessConceptForm';
import wealthBuildingSteps from './WealthBuildingStage';

export const surveySteps = [
  ...masterclassSteps,
  ...financesPhilanthropySteps,
  ...entrepreneurshipPhilanthropySteps,
  ...communityMindedBusinessConceptFormSteps,
 ...wealthBuildingSteps
];

export default surveySteps;

  